import { ReactNode, Component, PropsWithChildren, MouseEvent } from 'react'


interface Props {
    name: string

    checked: boolean
    isInvalid: boolean

    updateFlagCallBack: Function
}

interface State {
    checked: boolean
}

class PrivacyFlag extends Component<PropsWithChildren<Props>,State> {

    constructor (props: any) {
        super(props)

        this.state = {
            checked: false
        }

        this.onCLickHandler = this.onCLickHandler.bind(this)
    }

    componentDidUpdate (prevProps: Readonly<PropsWithChildren<Props>>, prevState: Readonly<State>, snapshot?: any): void {
        if (
            prevProps.checked !== this.props.checked &&
            this.props.checked !== this.state.checked
        ) {

            this.setState({
                checked: this.props.checked
            })
        }
    }

    render(): ReactNode {
        const containerClassName = (this.props.isInvalid) ? 'invalid falg-privacy' : 'falg-privacy'

        const checkClassName = (this.state.checked) ? 'active' : ''

        return (
            <div className={'form-input-contaier ' + containerClassName}>
                <input 
                    id={this.props.name}
                    className={checkClassName}
                    type="checkbox" 
                    autoComplete="off"
                    name={this.props.name}
                    checked={this.state.checked}
                    onChange={this.onChangeHandler}
                    onClick={this.onCLickHandler}
                />
                <label 
                    htmlFor={this.props.name}
                    onClick={this.onLabelClick}
                >
                    {this.props.children}
                </label>
            </div>
        )
    }


    // gestione del click
    private onCLickHandler (e: MouseEvent<HTMLInputElement | HTMLLabelElement>) {
        e.stopPropagation()
        e.preventDefault()

        this.setState ({
            checked: !this.state.checked
        }, () => {
            this.props.updateFlagCallBack (
                this.state.checked
            )
        })
    }


    /// volgio che funzioni al clik sulla select.. non al change o al click sulla label

    private onChangeHandler () {
        return false
    }

    private onLabelClick (e: MouseEvent<HTMLInputElement | HTMLLabelElement>) {
        e.stopPropagation()
        e.preventDefault()

        return false
    }
}

export default PrivacyFlag